var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2"},[_c('p',[_vm._v("Datos de certificado médico y médico certificante")]),_c('div',{staticClass:"cols2"},[_c('FileLink',{attrs:{"text":"Ver certificado médico","file-path":_vm.certificadoMedico.certificado}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }